import {ITEM_STORAGE} from "@/constant/constants.ts";

export const LocalStorage = {
    getLang() {
        return localStorage.getItem(ITEM_STORAGE.LANG) || null;
    },
    setLang(value: string) {
        localStorage.setItem(ITEM_STORAGE.LANG, value);
    },
    clearAuthenticationStorage() {
        localStorage.removeItem(ITEM_STORAGE.USER_INFO);
        localStorage.removeItem(ITEM_STORAGE.ACCESS_TOKEN);
        localStorage.removeItem(ITEM_STORAGE.REFRESH_TOKEN);
    },
    getAccessToken() {
        return localStorage.getItem(ITEM_STORAGE.ACCESS_TOKEN) || null;
    },
    setAccessToken(value?: string | null) {
        if (value) {
            localStorage.setItem(ITEM_STORAGE.ACCESS_TOKEN, value);
        }
    },
    getRefreshToken() {
        return localStorage.getItem(ITEM_STORAGE.REFRESH_TOKEN) || null;
    },
    setRefreshToken(value?: string | null) {
        if (value) {
            localStorage.setItem(ITEM_STORAGE.REFRESH_TOKEN, value);
        }
    },
    getExpiresDate() {
        return new Date(Number(localStorage.getItem(ITEM_STORAGE.EXPIRES_DATE)));
    },
    setExpiresDate(value?: Date | null) {
        if (value) {
            const date = new Date(value);
            localStorage.setItem(ITEM_STORAGE.EXPIRES_DATE, String(date.getTime()));
        }
    },
    getUserInfo() {
        const userInfo: LocalUserInfo = JSON.parse(localStorage.getItem(ITEM_STORAGE.USER_INFO) || "{}")
        return userInfo;
    },
    setUserInfo(value: LocalUserInfo) {
        localStorage.setItem(ITEM_STORAGE.USER_INFO, JSON.stringify(value));
    }
}